// Sử dụng biến môi trường
const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_BASE_URL_THINKSOFT = process.env.REACT_APP_API_URL_THINKSOFT;

const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/staff-login`,
  STAFF_INFO: `${API_BASE_URL}/staff/get-staff-info`,
  STAFF_SHIFT: `${API_BASE_URL}/kitchen/staff-shifts`,
  SELECT_MEAL: `${API_BASE_URL}/kitchen/select-meal`,
  // USE_TICKET: `${API_BASE_URL}/ticket/use-ticket`,
  // USE_TICKET_THINKSOFT: `${API_BASE_URL_THINKSOFT}`,
  // GET_CHECKED_TICKETS: `${API_BASE_URL}/staff/get-checked-tickets`,
  // GET_DASHBOARD_INFO: `${API_BASE_URL}/staff/get-dashboard-info`,
  // SAVE_NOTIFICATION_TOKEN: `${API_BASE_URL}/notifications/token`,
  // GET_NOTIFICATIONS: `${API_BASE_URL}/staff/get-notification`,
  // READ_NOTIFICATION: `${API_BASE_URL}/staff/read-notification`,
  // READ_ALL_NOTIFICATION: `${API_BASE_URL}/staff/read-all-notification`,
  // GET_SHIFT_REPORT: `${API_BASE_URL}/staff/get-shift-report`,
  // CHANGE_PASSWORD: `${API_BASE_URL}/staff/change-password`,
  // SAVE_REVIEW: `${API_BASE_URL}/reviews/save`,
  // Thêm các endpoint khác ở đây nếu cần
};

export { API_BASE_URL, API_ENDPOINTS };
